// extracted by mini-css-extract-plugin
export default {"Container":"CheckboxInput_Container__pcGUw","Label":"CheckboxInput_Label__JVnv5"};